// Family sharing validation -- iteration 077
import { z } from "zod";

export const updateFamilyGroupSchema = z.object({
  name: z.string().min(1).max(200),
});

export const inviteFamilyMemberSchema = z.object({
  email: z.string().email(),
  label: z.string().min(1).max(100),
});

export const addFamilyChildSchema = z
  .object({
    family_code: z.string().min(1).optional(),
    player_id: z.string().min(1).optional(),
  })
  .refine((v) => Boolean(v.family_code) !== Boolean(v.player_id), {
    message: "Provide exactly one of family_code or player_id",
  });

export const acceptFamilyInviteSchema = z.object({
  token: z.string().min(1),
});

export type UpdateFamilyGroupInput = z.infer<typeof updateFamilyGroupSchema>;
export type InviteFamilyMemberInput = z.infer<typeof inviteFamilyMemberSchema>;
export type AddFamilyChildInput = z.infer<typeof addFamilyChildSchema>;
export type AcceptFamilyInviteInput = z.infer<typeof acceptFamilyInviteSchema>;
